// const BACKEND_API_URL = 'http://localhost:8000/';
// const BACKEND_API_URL = 'https://bioluxe-express-api.vercel.app/';
// const BACKEND_API_URL = "http://46.182.172.161:7075/";
const BACKEND_API_URL = "https://bioluxe.am:8085";

export {
    BACKEND_API_URL,
}